export default __webpack_public_path__ + "static/media/gallery-wip-neck-base_00.af4f0979.jpg";